var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4786 17.6633L9.4356 30.0483L10.2256 30.1281L19.5337 17.677C19.5337 17.677 27.055 18.007 28.9039 17.8287C29.6004 17.7038 32.4304 17.2273 32.5443 15.7797L32.545 15.7634L32.545 15.747C32.4831 14.2966 29.6721 13.7185 28.9806 13.5686C27.1393 13.3238 19.611 13.3831 19.611 13.3831L10.7557 0.606148L9.96331 0.657184L15.5568 13.2517C15.5568 13.2517 11.8114 13.4764 9.88821 13.6582C7.96503 13.8401 3.51249 14.4761 3.51249 14.4761L0.363362 10.7697L0.153682 11.0047L1.75792 15.2102L0.381049 18.9146L0.582031 19.1567L3.48495 16.0071C3.48495 16.0071 7.91148 16.8029 9.82696 17.0537C11.7424 17.3044 15.4786 17.6633 15.4786 17.6633Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.1c836bdf3d1810b730caf1dabc83bac4.svg";
export { ForwardRef as ReactComponent };